// @TODO theese should be got from magento!
export const PREMIUM_MODULES_SKUS = [
  "Z.QV_SP", "Z.QV_24", "Z.QV_ME", "Z.QV_FT", "Z.QV_RE", "24LAND", "FINTECHLAND", "Z.SCNP","Z.QSNP_MXXXX1_AXXXY1","Z.ADNP",  
  "Z.SPNP_MXXXX1_AXXXY1","Z.SPRTNP_MXXXX1_AXXXY1","Z.FTNP"
];